import { render, staticRenderFns } from "./ClassifyData.vue?vue&type=template&id=42945f68&"
import script from "./ClassifyData.vue?vue&type=script&lang=js&"
export * from "./ClassifyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports